import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
  Signal,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faCalendarExclamation,
  faCheck,
  faExclamation,
  faNetworkWired,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { StatisticCardComponent } from '@lyceo/shared/ui';
import { TaskCountFacade } from '@lyceo/shared/task-count/data-access';
import { TaskCounts, TaskCountType } from '@lyceo/shared/task-count/util';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'lyceo-shared-task-counts',
  imports: [StatisticCardComponent, FaIconComponent, TranslocoDirective],
  templateUrl: './task-counts.component.html',
  styleUrls: ['./task-counts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskCountsComponent implements OnInit {
  private readonly taskCountFacade: TaskCountFacade = inject(TaskCountFacade);

  public readonly loading: Signal<boolean> = this.taskCountFacade.loading;
  public readonly error: Signal<string | null> = this.taskCountFacade.error;
  public readonly taskCounts: Signal<TaskCounts> =
    this.taskCountFacade.taskCounts;

  public readonly faExclamation: IconDefinition = faExclamation;
  public readonly faCalendarExclamation: IconDefinition = faCalendarExclamation;
  public readonly faNetworkWired: IconDefinition = faNetworkWired;
  public readonly faCheck: IconDefinition = faCheck;

  public readonly TaskCountType: typeof TaskCountType = TaskCountType;

  public ngOnInit(): void {
    this.taskCountFacade.getTaskCounts();
  }

  public taskCountClicked(taskCountType: TaskCountType): void {
    this.taskCountFacade.taskCountClicked(taskCountType);
  }
}
